import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {List} from "immutable";
import connect from "react-redux/es/connect/connect";
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import numeral from "numeral";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

// Actions
import {cleanSalesInvoices, getSalesInvoices} from "../../../actions/sales-invoices";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class CustomerInvoices extends Component {
    constructor(props) {
        super(props);

        this.state = {
            salesInvoiceFilters: ''
        };
    }
    componentDidMount() {
        this.props.getSalesInvoices({
            filters: { customer: this.props.customerId },
            projection: 'invoice_code document_date expiration_date customer statistics.subtotal statistics.vat statistics.total status',
            populateRefs: [{
                field: 'customer',
                projection: 'basic_info.name'
            }],
            calculateStatistics: 'sales-invoices',
            deleteVirtuals: true
        });
    }

    render() {
        let tableData = this.props.salesInvoices;

        // Filters Zone
        let totalInvoices = 0, totalUnpaid = 0;
        this.props.salesInvoices.forEach(invoice => {
            if (invoice.get('status') === 'unpaid') {
                totalUnpaid = totalUnpaid + invoice.getIn(['statistics', 'total']);
            }
            totalInvoices = totalInvoices + invoice.getIn(['statistics', 'total']);
        });
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label">{ numeral(totalInvoices).format() }</span>
                    <span>Total facturado</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                    <span>Total pendiente de cobro</span>
                </div>
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.salesInvoices.size || 0 }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: '' }) }><strong>Facturas</strong></span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.salesInvoices.count(order => order.get('status') === 'charged') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'charged' }) }>Cobradas</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.salesInvoices.count(order => order.get('status') === 'unpaid') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'unpaid' }) }>Pendientes</span>
                </div>
                { this.props.status === 'active'
                    ? <div className="col-auto ml-auto">
                        <button
                            className="btn btn-primary"
                            onClick={ () => this.props.history.push('/ventas/facturas/nuevo', { customerId: this.props.customerId }) }
                        >
                            <Icon icon="insert"/>Factura
                        </button>
                    </div>
                    : null
                }
            </div>
        );
        switch (this.state.salesInvoiceFilters) {
            case 'charged':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label">{ numeral(totalInvoices).format() }</span>
                            <span>Total facturado</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                            <span>Total pendiente de cobro</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.salesInvoices.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: '' }) }>Facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary"><strong>{ this.props.salesInvoices.count(order => order.get('status') === 'charged') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'charged' }) }><strong>Cobradas</strong></span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.salesInvoices.count(order => order.get('status') === 'unpaid') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'unpaid' }) }>Pendientes</span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/ventas/facturas/nuevo', { customerId: this.props.customerId }) }
                                >
                                    <Icon icon="insert"/>Factura
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.salesInvoices.filter(salesInvoice => salesInvoice.get('status') === 'charged');
                break;
            case 'unpaid':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label">{ numeral(totalInvoices).format() }</span>
                            <span>Total facturado</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                            <span>Total pendiente de cobro</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.salesInvoices.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: '' }) }>Facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.salesInvoices.count(order => order.get('status') === 'charged') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'charged' }) }>Cobradas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger"><strong>{ this.props.salesInvoices.count(order => order.get('status') === 'unpaid') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'unpaid' }) }><strong>Pendientes</strong></span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/ventas/facturas/nuevo', { customerId: this.props.customerId }) }
                                >
                                    <Icon icon="insert"/>Factura
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.salesInvoices.filter(salesInvoice => salesInvoice.get('status') === 'unpaid');
                break;
            default:
                break;
        }

        // SalesInvoices Table
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            invoice_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'invoice_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/ventas/facturas/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: "Fecha",
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            expiration_date: {
                title: "Fecha de vencimiento",
                columnType: 'date',
                dataField: 'expiration_date',
                width: 150,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            customer: {
                title: "Cliente",
                columnType: 'text',
                dataField: 'customer',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (status) => {
                    let data = { badgeColor: '', value: '' };

                    switch (status) {
                        case 'charged':
                            data.badgeColor = 'primary';
                            data.value = 'Cobrado';
                            break;
                        case 'unpaid':
                            data.badgeColor = 'danger';
                            data.value = 'Pendiente';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {data.value}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/facturas/' + value)} />
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div className="panel-body">
                { statsZone }
                <div className="row">
                    <div className="col">
                        <div className="ibox">
                            <div className="ibox-content">
                                <VirtualizedTable
                                    tableSettings={tableSettings}
                                    tableColumns={tableColumns}
                                    tableData={tableData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {

    // Reducers
    const salesInvoicesReducer = state.salesInvoices;

    // SalesInvoices
    let salesInvoices = salesInvoicesReducer.get('payload') || List([]);

    if (!(salesInvoices instanceof List)) {
        salesInvoices = List([])
    }

    return {
        salesInvoices
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSalesInvoices: (query) => dispatch(getSalesInvoices(query)),
        cleanSalesInvoices: () => dispatch(cleanSalesInvoices())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerInvoices);



// WEBPACK FOOTER //
// ./src/containers/sales/customers/CustomerInvoices.js